
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","width":"1.2em","height":"1.2em"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2zm8-8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zM6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    